import { t } from "@/i18n-js/instance";
import { Collapsible } from "@circle-react-uikit/Collapsible";
import { DimensionInput } from "../../../../Editor/fields/DimensionInput";
import type { ButtonType } from "./constants";

export const Sizing = ({ buttonType }: { buttonType: ButtonType }) => (
  <Collapsible title={t("builder_ui.prop_type.styles.size")} defaultOpen>
    <div className="px-6 pb-5">
      <div className="grid grid-cols-2 gap-x-4">
        <DimensionInput
          name={`styles.${buttonType}.sizing.width`}
          label={t("builder_ui.prop_type.styles.width")}
        />
        <DimensionInput
          name={`styles.${buttonType}.sizing.height`}
          label={t("builder_ui.prop_type.styles.height")}
        />
        <DimensionInput
          name={`styles.${buttonType}.sizing.minWidth`}
          label={t("builder_ui.prop_type.styles.min_width")}
        />
        <DimensionInput
          name={`styles.${buttonType}.sizing.minHeight`}
          label={t("builder_ui.prop_type.styles.min_height")}
        />
        <DimensionInput
          name={`styles.${buttonType}.sizing.maxWidth`}
          label={t("builder_ui.prop_type.styles.max_width")}
        />
        <DimensionInput
          name={`styles.${buttonType}.sizing.maxHeight`}
          label={t("builder_ui.prop_type.styles.max_height")}
        />
      </div>
    </div>
  </Collapsible>
);
